import { render, staticRenderFns } from "./SwitchAccessableCompany.vue?vue&type=template&id=427a948c&scoped=true"
import script from "./SwitchAccessableCompany.vue?vue&type=script&lang=js"
export * from "./SwitchAccessableCompany.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccessableCompany.vue?vue&type=style&index=0&id=427a948c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a948c",
  null
  
)

export default component.exports